import { render } from "./adminConference.vue?vue&type=template&id=02b90bf8&scoped=true"
import script from "./adminConference.vue?vue&type=script&lang=js"
export * from "./adminConference.vue?vue&type=script&lang=js"

import "./adminConference.vue?vue&type=style&index=0&id=02b90bf8&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b90bf8"]])

export default __exports__